import { Model } from '@/services/api/lib'

export default class Territory extends Model {
  resource () {
    return 'territories'
  }

  updateMethod () {
    return 'PATCH'
  }

  validations () {
    return {
      'country_code': 'required|string'
    }
  }

  defaults () {
    return {
      country_code: '',
      administrative_area: '',
      locality: '',
      dependent_locality: '',
      included_postal_codes: '',
      excluded_postal_codes: ''
    }
  }
}
